<div class="measure-units-page-container">
  @if (initialLoadFailed() && loadError(); as error) {
    <tf-settings-load-error
      [title]="error"
      [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
      [details]="loadErrorDetails()"
      [retrying]="isLoading()"
      (retry)="reload()" />
  } @else if (!hasLoadedOnce()) {
    <tf-settings-loading-placeholder [rows]="5" [columns]="3" />
  } @else if (showEmptyState()) {
    <tf-settings-inline-message
      [message]="actionError()"
      messageId="measure-units-action-error"
      (dismissed)="clearActionError()" />

    <tf-empty-state
      [title]="'SETTINGS_MEASURE_UNITS.EMPTY.TITLE' | translate"
      [body]="'SETTINGS_MEASURE_UNITS.EMPTY.BODY' | translate">
      <i
        empty-state-illustration
        class="pi pi-box measure-units-empty-illustration"
        aria-hidden="true"></i>
      <p-button
        empty-state-actions
        icon="pi pi-plus"
        [label]="'SETTINGS_MEASURE_UNITS.CREATE' | translate"
        [disabled]="!canCreate()"
        [pTooltip]="canCreate() ? '' : ('GENERAL.NO_PERMISSION' | translate)"
        tooltipPosition="top"
        (onClick)="openCreate()" />
      <p-button
        empty-state-actions
        icon="pi pi-refresh"
        severity="secondary"
        [loading]="isLoading()"
        [disabled]="isLoading()"
        [ariaLabel]="'SETTINGS_MEASURE_UNITS.RELOAD' | translate"
        (onClick)="reload()" />
    </tf-empty-state>
  } @else {
    <tf-settings-list-header
      [searchQuery]="searchQuery()"
      [searchPlaceholder]="'SETTINGS_MEASURE_UNITS.SEARCH_PLACEHOLDER' | translate"
      [loading]="isLoading()"
      [refreshTooltip]="'SETTINGS_MEASURE_UNITS.RELOAD' | translate"
      (searchChange)="onSearchChange($event)"
      (refresh)="reload()">
      <p-button
        headerActions
        [label]="'SETTINGS_MEASURE_UNITS.CREATE' | translate"
        icon="pi pi-plus"
        severity="primary"
        [disabled]="!canCreate()"
        [pTooltip]="canCreate() ? '' : ('GENERAL.NO_PERMISSION' | translate)"
        tooltipPosition="top"
        (onClick)="openCreate()" />
    </tf-settings-list-header>
    <tf-settings-inline-message
      [message]="actionError()"
      messageId="measure-units-action-error"
      (dismissed)="clearActionError()" />

    <tf-data-table
      [columns]="columns"
      [value]="filteredUnits()"
      [loading]="isLoading()"
      [paginator]="true"
      [rows]="pageSize"
      [currentPageReportTemplate]="'SETTINGS_MEASURE_UNITS.PAGINATION_MESSAGE' | translate"
      styleClass="p-datatable-sm"
      emptyMessageKey="SETTINGS_MEASURE_UNITS.NO_UNITS_FOUND">
      <ng-template tfColumnDef="_actions" let-unit>
        <p-button
          icon="pi pi-pencil"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          size="small"
          [disabled]="!canUpdate()"
          [pTooltip]="
            canUpdate() ? ('GENERAL.EDIT' | translate) : ('GENERAL.NO_PERMISSION' | translate)
          "
          tooltipPosition="top"
          (onClick)="openEdit(unit)" />
        <p-button
          icon="pi pi-trash"
          severity="danger"
          [text]="true"
          [rounded]="true"
          size="small"
          [disabled]="!canDelete()"
          [pTooltip]="
            canDelete() ? ('GENERAL.DELETE' | translate) : ('GENERAL.NO_PERMISSION' | translate)
          "
          tooltipPosition="top"
          (onClick)="deleteUnit(unit)" />
      </ng-template>
    </tf-data-table>
  }

  <tf-settings-measure-unit-dialog
    [visible]="dialogVisible()"
    [unit]="editTarget()"
    [isSaving]="isSaving()"
    (save)="onDialogSave($event)"
    (cancelled)="closeDialog()"
    (visibilityChange)="dialogVisible.set($event)" />

  <p-confirmDialog />
</div>
